import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { WebAppUser } from 'src/types/web-app-users';

type MeState = {
  me: WebAppUser | null;
  loading: boolean;
  error: string | null;
};

type Actions = {
  setLoading: (loading: boolean) => void;
  setMe: (newMe: WebAppUser | null) => void;
  setMeFromLogin: (adminUser: any) => void;
  clearMe: () => void;
};

const initialValues: MeState = {
  me: null,
  loading: false,
  error: null,
};

export const useMeStore = create<MeState & Actions>()(
  persist(
    (set) => ({
      ...initialValues,

      setLoading: (loading: boolean) => set({ loading }),

      setMe: (me: WebAppUser | null) => set({ me }),

      setMeFromLogin: (webAppUser: any) => {
        if (webAppUser) {
          const user: WebAppUser = {
            id: webAppUser.id,
            name: webAppUser.name,
            email: webAppUser.email,
            active: webAppUser.active,
            role: webAppUser.role,
          };
          set({ me: user });
        }
      },

      clearMe: () => set({ me: null, error: null }),
    }),
    {
      name: 'me-storage',
      partialize: (state) => ({ me: state.me }),
    }
  )
);
